import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import List from '@mui/material/List'
import { useAppState } from '@/contexts/StateContext'
import { Division } from '@/types/cohort'
import SelectMenuItem from './SelectMenuItem'

const NATIONAL_DIVISION = {
  name: 'National',
  type: 'all',
  latitude: 35.86,
  longitude: -98.26,
  timezone: 'US/Eastern'
}

interface RegionSelectMenuProps {
  onSelectMenu: (menu: Division) => void
}

const LogoSvg = () => (
  <svg
    width="144px"
    height="13.0212766px"
    viewBox="0 0 144 13.0212766"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>E0D4AAAD-8141-49E4-A287-03057C5D244C</title>
    <g id="Sketches" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="menu-logo"
        transform="translate(-558.000000, -115.000000)"
        fill="#A5CFEF"
        fillRule="nonzero"
      >
        <g id="lennar-logo-copy-3" transform="translate(558.000000, 115.000000)">
          <path
            d="M5.7334724,0 L0,0 L0,13.0198866 L15.987594,13.0198866 L15.987594,10.5095935 L5.7334724,10.5095935 L5.7334724,0 Z M19.6607951,13.0198866 L35.6483891,13.0198866 L35.6483891,10.5095935 L25.3942675,10.5095935 L25.3942675,7.74771517 L35.6483891,7.74771517 L35.6483891,5.2374221 L25.3942675,5.2374221 L25.3942675,2.51029308 L35.6483891,2.51029308 L35.6483891,0 L19.6607951,0 L19.6607951,13.0198866 Z M57.0860466,8.64563839 L46.7110595,0 L40.210716,0 L40.210716,13.0198866 L45.459337,13.0198866 L45.459337,4.33949888 L55.5925931,13.0198866 L62.3346676,13.0198866 L62.3346676,0 L57.0860466,0 L57.0860466,8.64563839 L57.0860466,8.64563839 Z M136.779507,5.91850937 C137.546378,5.30831077 137.910364,4.51880553 137.910364,3.55138361 C137.910364,2.87029635 137.667243,2.25870778 137.183781,1.79306648 C136.697541,1.32742519 136.012636,0.96881189 135.205476,0.644947944 C134.396928,0.358613297 133.51058,0.179306648 132.540877,0.0722786489 C131.424494,0.026226934 130.307314,0.00212939902 129.189984,0 L118.127314,0 L118.127314,13.0198866 L123.860786,13.0198866 L123.860786,2.40465505 L127.372833,2.40465505 C128.059127,2.40465505 128.623167,2.40465505 129.149696,2.44079437 C129.673447,2.4769337 130.118009,2.51168305 130.481995,2.62010102 C131.046035,2.76326835 131.41002,2.942575 131.651751,3.15802097 C131.894872,3.37346694 131.975449,3.65980159 131.975449,3.98227556 C131.975449,4.34088886 131.894872,4.62861348 131.69204,4.84405945 C131.530886,5.05950542 131.208578,5.2749514 130.844592,5.45286807 C130.441707,5.63356469 129.916567,5.77673202 129.31085,5.81148137 C128.705133,5.84762069 127.938262,5.88376002 127.050525,5.88376002 L124.911066,5.88376002 L132.458911,13.0212766 L139.484394,13.0212766 L133.549479,7.46138053 C134.962356,7.03048858 136.052924,6.53009793 136.779507,5.91850937 Z M100.485112,0 L92.4135168,13.0198866 L98.2664655,13.0198866 L103.595664,3.90999691 L105.897666,7.85474317 L102.424518,7.85474317 L100.929675,10.3664262 L107.38973,10.3664262 L108.923472,13.0212766 L114.77781,13.0212766 L106.703436,0 L100.485112,0 Z M83.8112243,8.64563839 L73.434848,0 L66.9358938,0 L66.9358938,13.0198866 L72.1831255,13.0198866 L72.1831255,4.33949888 L82.3163815,13.0198866 L89.0584561,13.0198866 L89.0584561,0 L83.8112243,0 L83.8112243,8.64563839 Z M139.442717,0.60880862 L140.290165,0.60880862 C140.573574,0.60880862 140.855593,0.717226593 140.855593,1.03970057 C140.855593,1.18286789 140.775016,1.36217454 140.613862,1.39831386 C140.775016,1.43445319 140.855593,1.61375983 140.855593,1.75692716 C140.855593,1.82920581 140.855593,2.04465178 140.93617,2.07940113 L140.492997,2.07940113 C140.452708,2.04465178 140.452708,1.90009448 140.452708,1.86534513 C140.452708,1.72078783 140.41242,1.57762051 140.209588,1.57762051 L139.88728,1.57762051 L139.88728,2.11554045 L139.442717,2.11554045 L139.442717,0.60880862 L139.442717,0.60880862 Z M139.88728,1.25514654 L140.249876,1.25514654 C140.370742,1.25514654 140.452708,1.18286789 140.452708,1.07444992 C140.452708,0.96881189 140.370742,0.932672566 140.249876,0.932672566 L139.88728,0.932672566 L139.88728,1.25514654 Z"
            id="Shape"
          ></path>
          <path
            d="M142.467392,2.80134972 C143.169201,2.80134972 143.737862,2.2342053 143.737862,1.53269608 C143.737862,0.829624486 143.169201,0.262480063 142.467392,0.262480063 C141.766969,0.262480063 141.198309,0.831186867 141.198309,1.53269608 C141.198309,2.2342053 141.766969,2.80134972 142.467392,2.80134972 Z M142.467392,3.06382979 C143.313447,3.06382979 144,2.37794438 144,1.53269608 C144,0.685885404 143.313447,0 142.467392,0 C141.621336,0 140.93617,0.685885404 140.93617,1.5311337 C140.93617,2.37794438 141.621336,3.06382979 142.467392,3.06382979 Z"
            id="Shape"
          ></path>
        </g>
      </g>
    </g>
  </svg>
)

const RegionSelectMenu = ({ onSelectMenu }: RegionSelectMenuProps) => {
  const { locations } = useAppState()

  return (
    <Stack sx={{ width: 1260, backgroundColor: 'background.paper', p: 4 }} alignItems="center">
      <Box
        onClick={() => onSelectMenu(NATIONAL_DIVISION)}
        role="button"
        tabIndex={-1}
        sx={{
          cursor: 'pointer',
          borderBottom: '1px solid transparent',
          '&:hover': {
            borderBottom: '1px solid #fff',
            '#menu-logo': {
              fill: '#fff'
            }
          }
        }}
      >
        <LogoSvg />
      </Box>
      <Grid container sx={{ mt: 3 }}>
        {locations.map((region) => (
          <Grid key={region.name} item lg={3} sx={{ maxWidth: '20% !important' }}>
            <Button
              sx={{
                color: 'grey.300',
                fontSize: 24,
                lineHeight: 2,
                fontWeight: 700,
                '&:hover': {
                  color: 'white',
                  textDecoration: 'underline'
                }
              }}
              onClick={() => onSelectMenu(region)}
            >
              {region.name}
            </Button>
            <List>
              {region.divisions.map((item) => (
                <SelectMenuItem key={item.name} item={item} onSelectMenu={onSelectMenu} />
              ))}
            </List>
          </Grid>
        ))}
      </Grid>
    </Stack>
  )
}

export default RegionSelectMenu
